import { useQuery } from "@tanstack/react-query";
import { getMedicalRecordRequest } from "../../api/medical-record-requests.api";
import { MedicalRecordRequest } from "../../api/medical-record-requests.type";

export function useMedicalRecordRequest(id?: string, enabled: boolean = true) {
  return useQuery<MedicalRecordRequest>({
    queryKey: ["medical-record-request", id],
    queryFn: () => {
      if (!id) {
        throw new Error("request id is required");
      }
      return getMedicalRecordRequest(id);
    },
    enabled: Boolean(id) && enabled,
  });
}

export default useMedicalRecordRequest;
